var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredList.length),expression:"filteredList.length"}],class:[
		'toast-list',
		{ fixed: _vm.fixed, bottom: _vm.bottom }
	]},[_c('div',{staticClass:"toast-list__wrapper"},_vm._l((_vm.filteredList),function(i,idx){return _c('Toast',{key:'toast-item-' + idx,attrs:{"item":i}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }